export default __webpack_public_path__ + "static/media/atd-logo-small.a3f91e1a.svg";